import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {
  private toggles: Record<string, boolean> = {};

  constructor(private http: HttpClient) {}

  loadToggles(): Promise<void> {
    return new Promise((resolve) => {
      this.http.get<Record<string, boolean>>('/assets/feature-toggles.json').pipe(
        tap(data => {
          this.toggles = data ?? {};
          console.log('[Features] Toggles loaded successfully.');
        }),
        catchError(error => {
          console.error('[Features] Failed to load feature-toggles.json. All features will be disabled by default.', error);
          this.toggles = {};
          return of({});
        })
      ).subscribe(() => {
        resolve();
      });
    });
  }

  isEnabled(flag: string): boolean {
    return this.toggles[flag] ?? false;
  }
}
